import {getLibraryInfo, getConfig} from '../../../common/config'
import Select from '../../../components/select.vue'
import Footer from '../../../components/footer.vue'
import webFooter from '../../../components/webFooter.vue'
import lunbo from '../../../components/lunbo.vue'
import zixun from '../../../components/zixun.vue'
import $ from 'jquery'
import activity from '../../../components/activity.vue'
import {api,imgPath} from '../../../common/config.js'
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {store} from '../../../store/store.js';
import {CommonUtil} from '../../../common/CommonUtil.js';
import {StorageUtil, LocalStorageUtil} from '../../../common/Auth.js';

export default {
  components: {
    Select,
    Footer,
    lunbo,
    zixun,
    activity,
    webFooter
  },
  data: function () {
    return {
      imgPath:imgPath,
      top: 0,
      height: 0,
      active1: 0,
      active2: 0,
      active3: 0,
      active4: 0,
      active5: 0,
      imgError: store.imgError,
      test: 'test',
      keyword: '',
      select: {desc: '图书'},
      list: [{desc: '图书'}, {desc: '电子书'}, {desc: '图书馆'}, {desc: '资讯'}, {desc: '活动'}],
      ranking: [],
      hotEbooks: [],
      hotTypes: [],
      wellBook: [],
      recommendEbooks: [],
      informations: [],
      activitys: [],
      informationsIds: [],
      informationsTotalPage: 0,
      informationsPageCount: 3,
      activityIds: [],
      activityTotalPage: 0,
      activityPageCount: 3,
      imgErrorLlibrary: store.imgError_library,
      hallCodeInformations: [],
      hallCodeInformationPageCount: 0,
      hallCodeActivity: [],
      hallCodeActivityPageCount: 0,
      informationPageCount: 0,
      libraryInfoData: {},
      source: {},
      lightTime: {},
      libCode: '',
      libId: '',
      fromSearch: 0,
      latLng: '',
      libLevel: '',
      name: '',
      webType: store.webType,
      locationCode: store.localtionArea.code,
      totalPage: store.webType == 0 ? 5 : 4,
      hallCodeParams: '',
      moreIntroduce:''
    }

  },
  beforeMount() {
    if (store.webType == 1) {
      this.list = [{desc: '图书'}, {desc: '电子书'}, {desc: '资讯'}, {desc: '活动'}]
    }
    store.wrap.showFooter = false;
    this.libLevel = this.$route.query.libLevel || store.library.libraryLevel || '';
    this.latLng = this.$route.query.latLng || store.localtionArea.latLng || '';
    this.name = this.$route.query.name || store.library.name || '';
    this.fromSearch = this.$route.query.fromSearch || 0;
    this.libId = this.$route.query.libId || store.library.id || '';
    this.libCode = this.$route.query.libCode || this.$route.query.hallCode || '';
    if (store.webType == 1) { /*获取图书馆信息*/
      this.hallCodeParams = this.libCode;
    }
    if (store.webType == 0) {
      Promise.all([this.rankingList(), this.wellBookList(), this.informationFunc(), this.activityFunc()])
    } else {
      Promise.all([this.rankingList(), this.wellBookList(), this.getLibrary(), this.hallCodeInformation(), this.hallCodeactivityFunc()])
    }
      if(store.opacType === 1){//进入OPac首页
          this.$router.push({path:'OPACIndex', query:{hallCode: this.libCode,libId: this.libId, libLevel: this.libLevel, libraryname: this.name, latLng:this.latLng, fromSearch:this.fromSearch }})
      }
  },

  beforeRouteLeave(to, from, next) {
    store.wrap.activeRouteName = '';
    setTimeout(function () {
      store.wrap.showFooter = true;
    }, 1000)
    next()
  },

  mounted() {
    store.wrap.activeRouteName = '首页';
    var _this = this;
    var startY, moveEndY
    var canMove = true;
    $("body").on("touchstart", function (e) {
      startY = e.originalEvent.changedTouches[0].pageY;
    });
    $("body").on("touchmove", function (e) {
      if (!canMove) {
        return false
      }
      moveEndY = e.originalEvent.changedTouches[0].pageY;
      var y = moveEndY - startY;
      _this.moveTouch(y)
      canMove = false
    });
    $("body").on("touchend", function (e) {
      // e.preventDefault()
      canMove = true;
    });
    if (CommonUtil.changeExpiredCode(this, store)) {
      return;
    }
    this.browserCompatibility();
    setTimeout(this.initLocationCodeFunc, 2000);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {

    // 图书馆详情
    getLibrary() {
      var url = api.library.info.replace('{fromSearch}', this.fromSearch).replace('{flag}', 1).replace('{libId}', this.libId).replace('{lngLat}', this.latLng);
      ajaxUtil.ajaxJson(url, null, "GET", (data) => {
        this.libraryInfoData = data;
        this.moreIntroduce = this.libraryInfoData.htmlInfo.content;
      }, null, this);
    },

    rankingList() {
      ajaxUtil.ajaxJson(api.index.ranking.replace('{libCode}', this.hallCodeParams), null, "GET", (data)=> {
        this.ranking = data;
        StorageUtil.storeString("deposit",data.bookSearch[0].deposit);
      }, null, this);
    },

    wellBookList() {
      var url = api.index.recommendGoodEBooks.replace('{pageNo}', 1).replace('{pageCount}', 18).replace('{categoryId}', 0);
      ajaxUtil.ajaxJson(url, null, "GET", (data)=> {
        this.wellBook = data;
      }, null, this);
    },

    //本馆资讯
    hallCodeInformation() {
      this.informationsIds=[];
      let url = api.library.libNews.replace('{libCode}',this.libCode).replace('{pageCount}', 3).replace('{pageNo}', 1);
      ajaxUtil.ajaxJson(url, null, "GET", (data)=> {
        this.hallCodeInformations = data.resultList;
        this.informationsTotalPage = data.totalPage;
        if (this.hallCodeInformations != null) {
            for (let i = 0; i < this.hallCodeInformations.length; i++) {
                this.informationsIds.push(this.hallCodeInformations[i].newsId);
            }
        }
      }, null, this);
    },


    /**
     * 本馆活动
     * @returns {Promise.<void>}
     */
    hallCodeactivityFunc() {
      this.activityIds=[];
      let url = api.activity.activitys.replace('{libCode}',this.libCode).replace('{pageNo}', 1).replace('{pageCount}', 3).replace('{keyword}', "");
      ajaxUtil.ajaxJson(url, null, "GET", (data)=> {
        this.hallCodeActivity = data.resultList;
        this.activityPageCount = data.pageCount;
        this.activityTotalPage = data.totalPage;
        if (this.hallCodeActivity != null) {
            for (let i = 0; i < this.hallCodeActivity.length; i++) {
                this.activityIds.push(this.hallCodeActivity[i].id);
            }
        }
      }, null, this);
    },
    /**
     * 资讯
     */
    informationFunc: function () {
      this.informationsIds=[];
      let url = api.information.search.replace('{pageNo}', 1).replace('{pageCount}', this.informationsPageCount).replace('{locationCode}', store.chooseArea.code).replace('{keyword}', "");
      ajaxUtil.ajaxJson(url, null, "GET", (data) => {
        this.informations = data.resultList;
        this.informationPageCount = data.pageCount;
        this.informationsTotalPage = data.totalPage;
        if (this.informations != null) {
          for (let i = 0; i < this.informations.length; i++) {
            this.informationsIds.push(this.informations[i].newsId);
          }
        }
      }, null, this);
    },
    /**
     * 活动
     */
    activityFunc: function () {
      this.activityIds=[];
      let url = api.activity.search.replace('{pageNo}', 1).replace('{pageCount}', this.activityPageCount).replace('{locationCode}', store.chooseArea.code).replace('{keyword}', "");
      ajaxUtil.ajaxJson(url, null, "GET", (data) => {
        this.activitys = data.resultList;
        this.activityPageCount = data.pageCount;
        this.activityTotalPage = data.totalPage;
        if (this.activitys != null) {
          for (let i = 0; i < this.activitys.length; i++) {
            this.activityIds.push(this.activitys[i].id);
          }
        }
      }, null, this);
    },
    initLocationCodeFunc: function () {
      if(store.webType === 0){
          this.informationFunc();
          this.activityFunc();
      }else{
        this.hallCodeInformation();
        this.hallCodeactivityFunc();
      }

    },
    /**
     *
     * 页面跳转类
     *
     */
    //快速搜索
    search: function () {
      var keyword = this.keyword;
      if (keyword.trim() == "") {
        this.keyword = "";
        $('.searchInput').focus();
        return;
      }
      var type = -1;
      var searchType = this.select.desc;
      if (searchType === "图书") {
        type = 1;
      } else if (searchType === "电子书") {
        type = 2;
      } else if (searchType === "图书馆") {
        type = 3;
      } else if (searchType === "活动") {
        type = 4;
      } else if (searchType === "资讯") {
        type = 5;
      }
      this.$router.push({
        path: 'indexsearch',
        query: {searchStr: keyword, type: type, code: store.chooseArea.code, fromSearch: 0, hallCode: this.libCode}
      });
    },
    //高级搜索
    seniorSearch: function () {
      var searchType = this.select.desc;
      if (searchType === "图书") {
        this.$router.push({path: '/searchbook', query: {fromSearch: 0, hallCode: this.libCode, typeId:0 }});
      } else if (searchType === "电子书") {
          this.$router.push({path: '/searchbook', query: {fromSearch: 0, hallCode: this.libCode, typeId:1 }});
      } else if (searchType === "图书馆") {
        this.$router.push({path: '/searchlibrary', query: {fromSearch: 0, hallCode: this.libCode}});
      } else if (searchType === "资讯") {
          this.$router.push({path: '/searchbook', query: {fromSearch: 0, hallCode: this.libCode, typeId:2 }});
      }
    },
    //进入图书详情页
    intoBooksDetail: function (isbn, type) {
      if (type === "book") {
        this.$router.push({path: 'bookcontent', query: {isbn: isbn}});
      } else if (type === "ebook") {
        this.$router.push({path: 'ebookinfo', query: {id: isbn}});
      }
    },
    //进入排行榜页面
    intoMoreBooks: function (type) {
      this.$router.push({path: 'rankList', query: {rankingClass: type, hallCode: this.libCode}});
    },
    //进入电子书搜索页面
    intoEboks: function () {
      this.$router.push('ebook');
    },
    //进入好书推荐更多
    toMore: function () {
      this.$router.push('/referbook');
    },

    //进入活动/资讯列表
    intoInformationActivityList: function (type) {
      if (type === "information") {
        this.$router.push({
          path: 'informationList',
          query: {code: store.chooseArea.code, hallCode: this.$route.query.hallCode}
        });
      } else if (type === "activity") {
        this.$router.push({
          path: 'activitylist',
          query: {code: store.chooseArea.code, hallCode: this.$route.query.hallCode}
        });
      }
    },
    //进入活动/资讯详情
    intoInformationActivityDetail: function (id, type) {

      var code = this.$route.query.code;
      if (type === "information") {
        var data = {
          ids: this.informationsIds,
          totalCount: this.informations.length,
          pageNo: 1,
          pageCount: this.informationPageCount,
          totalPage: this.informationsTotalPage,
        };
        StorageUtil.storeObject("informationInfo", data);
        this.$router.push({path: 'infordetails', query: {newsId: id, fromSearch: 0, code: code}});
      } else if (type === "activity") {
        var data = {
          ids: this.activityIds,
          totalCount: this.activitys.length,
          pageCount: this.activityPageCount,
          pageNo: 1,
          totalPage: this.activityTotalPage
        };
        StorageUtil.storeObject("activityInfo", data);
        this.$router.push({path: '/activitydetails', query: {activityId: id}});
      }
    },

      /*
       * 进入本馆介绍
       **/
      toIntroduce(){
          this.$router.push({path: 'webintroduce', query: {libId: this.libId, fromSearch: this.fromSearch, libCode:this.libCode, latLng:this.latLng, libLevel:this.libLevel}});
      },
    /*
     * 进入关于我们
     * */
    showAbout: function () {
      this.$router.push('/about')
    },

    /**
     *
     * 下面是页面切换方法
     *
     */
    //排行榜,热门电子书切换效果
    getActive(n, type) {
      if (type == 1) {
        this.active1 = n
      } else if (type == 2) {
        this.active2 = n
      } else if (type == 3) {
        this.active3 = n
      } else if (type == 4) {
        this.active4 = n
      } else if (type == 5) {
        this.active5 = n
      }
    },
    //切换效果方法
    changeIndexPage(direction) {
      var distance = parseFloat(window.getComputedStyle(document.body).height);
      var copyDistance = distance;
      if (direction < 0) {
        distance = 0 - distance;
      }
      this.clock(this.top, distance, 500, 0, -(this.totalPage - 1) * copyDistance);
    },
    moveTouch(num) {
      var distance = parseFloat(window.getComputedStyle(document.body).height);
      var copyDistance = distance;
      var now = Math.abs(this.top) / parseFloat(this.height) + 1;
      var n = num > 0 ? now - 1 : now + 1
      if (n < 0 || n > this.totalPage) return false;
      distance = (now - n) * distance;
      this.clock(this.top, distance, 500, 0, -(this.totalPage - 1) * copyDistance);
    },
    //快速访问切换
    toPage(n) {
      var distance = parseFloat(window.getComputedStyle(document.body).height);
      var copyDistance = distance;
      var now = Math.abs(this.top) / parseFloat(this.height) + 1;
      distance = (now - n) * distance;
      this.clock(this.top, distance, 500, 0, -(this.totalPage - 1) * copyDistance);
    },
    clock(nowPos, distance, time, max, min) {
      if (this.isMove) {
        return false;
      }
      var destination = nowPos + distance
      var timer = null;
      var now = new Date();
      var speed = distance / time;
      timer = setInterval(() => {
        this.isMove = true;
        var moveDate = new Date();
        if (moveDate - now > time) {
          this.isMove = false;
          this.top = destination;
          clearInterval(timer);
          return false;
        } else if (nowPos + speed * (moveDate - now) > max) {
          this.isMove = false;
          this.top = max;
          clearInterval(timer);
          return false;
        } else if (nowPos + speed * (moveDate - now) < min) {
          this.isMove = false;
          this.top = min;
          clearInterval(timer);
          return false;
        }
        this.top = nowPos + speed * (moveDate - now);
      }, 1)
    },
    getHeight() {
      setTimeout(() => {
        this.height = window.getComputedStyle(document.body).height;
      }, 30)
    },
    //浏览器兼容
    browserCompatibility() {
      window.addEventListener('resize', this.getHeight)
      this.height = window.getComputedStyle(document.body).height;
      if (CommonUtil.checkPlatform() == 1) {
        return false
      }
      this.$refs.pageWrapper.addEventListener('DOMMouseScroll', (ev) => { //火狐
          this.changeIndexPage(-ev.detail)
      }, false);
      this.$refs.pageWrapper.addEventListener('mousewheel', (ev) => { //火狐之外
          this.changeIndexPage(ev.wheelDelta)
      }, false)
    }
  },
}
